import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  /* Reset and base styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f8fafc;
    color: #334155;
    min-width: 0;
    overflow-x: hidden;
  }

  html,
  body,
  #root {
    width: 100%;
    min-height: 100%;
  }

  img,
  video,
  canvas,
  svg {
    max-width: 100%;
  }

  button,
  input,
  select,
  textarea {
    font: inherit;
  }

  table {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    input,
    select,
    textarea {
      max-width: 100%;
      font-size: 16px !important;
    }

    table {
      display: block;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    [role="dialog"] {
      width: calc(100vw - 24px) !important;
      max-width: calc(100vw - 24px) !important;
      max-height: calc(100dvh - 24px) !important;
      overflow-y: auto;
    }

    .Toastify__toast-container {
      left: 8px;
      right: 8px;
      width: auto;
    }
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
`;
